export default __webpack_public_path__ + "static/media/IMG_9943 copie.8162056a.jpg";